import { useContext, useEffect, useState } from "react"
import _ from "lodash"

//Context
import { AssessmentFormulaBuilderContext } from "../../../../../../context/assessmentFormulaBuilderContext"

//Drag and Drop
import {
  horizontalListSortingStrategy,
  SortableContext,
} from "@dnd-kit/sortable"

//PrimeReact
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"

//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import assessStyles from "../../../../../../styles/assessments/Assessment.module.css"

//Formula Builder components
import Droppable from "../../Droppable"
import RenderFormula from "./RenderFormula"
import formulaBuilderTypes from "../formulaBuilderTypes"
import RenderFormulaConnector from "./RenderFormulaConnector"
import {
  functionAcceptsMoreValues,
  functionTypeAcceptsQuestionType,
  getFunctionByName,
} from "../Helpers/formulaHelpers"
import { classNames } from "primereact/utils"
import { InputNumber } from "primereact/inputnumber"
import RenderFormulaClose from "./RenderFormulaClose"

export default function RenderFormulaFunction({
  formulaOrder,
  dndRef,
  dndStyle,
  dndAttributes,
  dndListeners,
  hideConnector,
  overConnectorId,
}) {
  const { onUpdateFormulaEntry, draggingObject, newFormulaOrder } = useContext(
    AssessmentFormulaBuilderContext
  )
  const [disableBody, setDisableBody] = useState(false)

  useEffect(() => {
    if (draggingObject) {
      if (
        !functionAcceptsMoreValues(
          formulaOrder,
          newFormulaOrder || draggingObject.formulaOrder
        )
      ) {
        setDisableBody(true)
      } else if (!AcceptDraggedType(formulaOrder, draggingObject)) {
        setDisableBody(true)
      } else if (disableBody) {
        setDisableBody(false)
      }
    } else if (disableBody) {
      setDisableBody(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draggingObject, formulaOrder?.function?.values])

  function AcceptDraggedType(thisFunction, draggedObject) {
    let acceptsType = true

    if (
      draggedObject?.object?.question ||
      draggedObject.formulaOrder?.question
    ) {
      acceptsType = functionTypeAcceptsQuestionType(
        thisFunction?.function?.type,
        draggedObject?.object?.question?.type ||
          draggedObject.formulaOrder?.question?.type
      )
    }

    return acceptsType
  }

  const functionConfig = getFunctionByName(formulaOrder?.function?.type)

  let functionProfile = formulaOrder?.function
  let functionType = formulaBuilderTypes.getFunction(functionProfile?.type)
  let display =
    functionType?.display?.replace("()", "") || functionProfile?.type

  return (
    <>
      {!hideConnector ? (
        <div className={myStyles.formulaRenderLayoutConnector}>
          <RenderFormulaConnector
            connector={functionProfile?.connectingOperator}
            formulaId={formulaOrder?.id}
            overConnectorId={overConnectorId}
          />
        </div>
      ) : null}

      <div
        className={classNames(
          myStyles.formulaFunctionLayout,
          functionConfig?.hasOffset
            ? myStyles.formulaFunctionLayoutWithNumber
            : ""
        )}
        {...dndAttributes}
        {...dndListeners}
        style={dndStyle}
        ref={dndRef}
      >
        <div className={myStyles.formulaFunctionLayoutTitle}>
          <InputText
            value={functionProfile?.title}
            placeholder="Add title"
            className={myStyles.formulaFunctionLayoutTitleInput}
            onChange={(e) => {
              let newValue = _.cloneDeep(formulaOrder)
              newValue.function.title = e.target.value

              onUpdateFormulaEntry(newValue)

              e.stopPropagation()
            }}
            onKeyDown={(e) => {
              e.stopPropagation()
            }}
            onMouseDown={(e) => {
              e.stopPropagation()
            }}
            onFocus={(e) => {
              e.stopPropagation()
            }}
            data-no-dnd
          />
        </div>
        {functionConfig?.hasOffset && (
          <>
            <div className={myStyles.formulaFunctionLayoutLabel}>Offset</div>
            <div className={myStyles.formulaFunctionLayoutNumber}>
              <InputNumber
                value={functionProfile.attribute}
                onChange={(e) => {
                  let newValue = _.cloneDeep(formulaOrder)
                  newValue.function.attribute = e.value

                  onUpdateFormulaEntry(newValue)
                }}
                className={myStyles.formulaRenderAttributeInput}
                showButtons
                buttonLayout="horizontal"
                min={0}
                data-no-dnd
              />
            </div>
          </>
        )}
        <div className={myStyles.formulaFunctionLayoutControls}>
          <RenderFormulaClose formulaOrderid={formulaOrder.id} />
          <Button
            className={`${assessStyles.actionButton} ${myStyles.formulaRenderGroupHeaderLayoutControlsButton}`}
            type="button"
            tooltip="Drag this element to order it in the list"
            tooltipOptions={{ position: "bottom" }}
          >
            <span className={`material-icons`}>{"drag_indicator"}</span>
          </Button>
        </div>
        <div className={myStyles.formulaFunctionLayoutBody}>
          {!disableBody ? (
            <Droppable
              id={`FormulaFunction_${functionProfile?.id}`}
              className={myStyles.formulaFunctionLayoutBodyDroppable}
            >
              {`${display}(`}

              <div
                className={`${myStyles.formulaFunctionLayoutBodyContainer} ${
                  functionProfile?.values?.length === 0
                    ? myStyles.formulaFunctionLayoutBodyContainerEmpty
                    : ""
                }`}
              >
                <SortableContext
                  items={functionProfile?.values.map((formula) => formula.id)}
                  strategy={horizontalListSortingStrategy}
                >
                  {functionProfile?.values?.length === 0 ? (
                    <>{"Add question or number"}</>
                  ) : (
                    functionProfile?.values.map((value) => {
                      return (
                        <RenderFormula
                          formulaOrder={value}
                          key={value?.id}
                          hideConnector={true}
                        />
                      )
                    })
                  )}
                </SortableContext>
              </div>

              {")"}
            </Droppable>
          ) : (
            <>Unable to accept object</>
          )}
        </div>
      </div>
    </>
  )
}
